/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmCommandInstanceExecutionDetail {
    getFixupPrototypeFunction() { return AwsSsmCommandInstanceExecutionDetail.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmCommandInstanceExecutionDetail>): AwsSsmCommandInstanceExecutionDetail {
        let obj = Object.assign(new AwsSsmCommandInstanceExecutionDetail(), model);
        AwsSsmCommandInstanceExecutionDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmCommandInstanceExecutionDetail>): AwsSsmCommandInstanceExecutionDetail {
        if (!model) return null;
        return AwsSsmCommandInstanceExecutionDetail.newInstance(<AwsSsmCommandInstanceExecutionDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmCommandInstanceExecutionDetail) {
        if (!obj) return;

        models.AwsSsmCommandInstanceExecutionDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmCommandInstanceExecutionDetail): boolean {
        Object.setPrototypeOf(obj, AwsSsmCommandInstanceExecutionDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.execution_start_time === "string") {
            this.execution_start_time = new Date(<string><any>this.execution_start_time);
        }
        if (typeof this.execution_end_time === "string") {
            this.execution_end_time = new Date(<string><any>this.execution_end_time);
        }
        if (this.command_plugins) {
            for (let val of this.command_plugins) {
                models.AwsSsmCommandPlugin.fixupPrototype(val);
            }
        }
    }

    /**
     * Id of the command execution
     */
    sysId: string;

    /**
     * Id of the command execution job
     */
    job_id: string;

    /**
     * The ID of the instance on which the command document is executed.
     */
    instance_id: string;

    /**
     * The Name of the instance on which the command document is executed.
     */
    instance_name: string;

    /**
     * The comment text for the command.
     */
    comment: string;

    /**
     * The date and time the plugin started running.
     */
    execution_start_time: Date;

    /**
     * The date and time the plugin finished running.
     */
    execution_end_time: Date;

    /**
     * Status of the Execution
     */
    status: models.AwsSsmCommandExecutionStatus;

    /**
     * Detailed status of the execution
     */
    status_details: string;

    /**
     * Plugin details of the command execution
     */
    command_plugins: Array<models.AwsSsmCommandPlugin>;

}
